import React, { useContext, useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { Form, Input,InputNumber,Select,Typography,Popconfirm,Switch,Checkbox,Radio,TimePicker,AutoComplete,DatePicker,ColorPicker,Card,Button} from 'antd';
import {ExpandOutlined,CloseOutlined} from '@ant-design/icons';
import _ from 'lodash';
import Language from 'components/language';
const {Paragraph}=Typography;

export const getInput=({type,format,options,moptions,minWidth="50px",schema,data,parentData,filters,...props})=>{
  
  return (
    type==="autocomplete"?<AutoComplete  {...props}/>:
    // type==="Cascader"?<Cascader  {...props}/>:
    // type==="CircleRange"?<CircleRange  {...props}/>:
    // type==="LineRange"?<LineRange  {...props}/>:
    // type==="Color"?<Color color={value} {...props} onChange={(value)=>form.setFieldsValue({[name]:value})} />:
    // type==="ColorRange"?<ColorRange {...props} onChange={(value)=>form.setFieldsValue({[name]:value})}/>:
     type==="selectExtent"?<div style={{display:"flex",alignItems: "center"}}> <Button disabled={true||props?.selectDisabled} size="small" icon={<ExpandOutlined />} onClick={()=>props?.onClick&&props?.onClick()}></Button>  <Select
      {...props}
      disabled={props?.disabled || props?.selectDisabled}
      mode="multiple"
       style={{
        width: '100%',
        minWidth
      }}
      allowClear     
      placeholder={props?.placeholder ??"Please select"}           
      options={_.isFunction(moptions)?moptions({onChange:props?.onChange}):moptions}
      maxTagCount={1}
    /></div>:
    type==="select"?<Select
      {...props}
      mode="multiple"
       style={{
        width: '100%',
        minWidth
      }}
      allowClear     
      placeholder={props?.placeholder ??"Please select"}                    
      options={moptions}
      maxTagCount={10}
    />:
    options?<Select   showSearch={true} style={{width:"100%"}} filterOption={(input, option) =>(option?.children ?? '').includes(input)}  {...props}>
      {options.map(({key,label},i)=><Select.Option key={key} value={key}>{label}</Select.Option>)}
      </Select>:
    type==="string"&&format==="hex"?<ColorPicker  {...props} onChange={(color,hex)=>props?.onChange&&props?.onChange(hex)} />:
    type==="paragraph"?<Paragraph key={props.key} editable={{onChange: props.onChange,text: props.value}}>{props.value}</Paragraph>:
    type==="boolean"?<Checkbox checked={props?.value} {...props} onChange={(e)=>props?.onChange&&props?.onChange(e.target.checked)}/>:
    type==="string"&&format=="date"?<DatePicker  {...props} />:
    // type==="Gradient"?<Gradient button={true} {...props} onChange={(value)=>form.setFieldsValue({[name]:value})}/>:
    
    type==="string"?<Input  {...props} onChange={(e)=>props?.onChange&&props?.onChange(e.target.value)}/>:    
    
    type==="number"||type==="integer"?<InputNumber  {...props}/>:
    // type==="LinearScale"?<LinearScale  {...props}/>:
    // type==="Mentions"?<Mentions  {...props}>{items?items.map((item,i)=><Mentions.Option key={i} value={item}>{item}</Mentions.Option>):null}</Mentions>:
    type==="radio"?<Radio.Group {...props}>
      {options?options.map(({key,label},i)=><Radio key={key} value={key}>{label}</Radio>):null}
      </Radio.Group>:
    // type==="Rate"?<Rate  {...props}/>:      
    // type==="Slider"?<Slider  {...props}/>:
    type==="switch"?<Switch  {...props}/>:
    type==="time"?<TimePicker  {...props}/>:
    
    // type==="Transfer"?<Transfer  {...props}/>:
    // type==="TreeSelect"?<TreeSelect  {...props}/>:
    // type==="Upload"?<Upload  {...props}/>:
    null
  )
}
export const generateFormFields = ({form,schema,parentData,tailFormItemLayout,parentKey}) => {
  return Object.keys(schema.properties).map((key) => getFormItem({form,schema,key,parentData,tailFormItemLayout,parentKey}));
};
export const getFormItem=(props)=>{  
    
    const { form,ref, schema,parentData,key,tailFormItemLayout={},hideLabel=false,parentKey } = props;
    const property = schema.properties[key];
    
    const {label,dependencies, type, options:_options, format,hidden,formTitle,tooltip,showSearch,getOptionsWithRowData,shouldUpdate,...inputs} = property||{};
       
    const isRequired = schema.required && schema.required.includes(key);  
    let other = type==="boolean"?{valuePropName:"checked",...tailFormItemLayout}:    
    type==="color"?{getValueFromEvent:(color,hex)=>hex}:
    {};
    // console.log("shouldUpdate",shouldUpdate)
    // if(shouldUpdate)other={...other,shouldUpdate};
    if(type=="object" && !hidden){      
      if(formTitle){
        return <Card title={formTitle}> 
          {generateFormFields({schema:property,parentData,key,parentKey:parentKey?[...parentKey,key]:[key]})}
        </Card>
      } else {
        return <div> 
          {generateFormFields({schema:property,parentData,key,parentKey:parentKey?[...parentKey,key]:[key]})}
        </div>
        }
    }    
  // console.log("shouldUpdate",shouldUpdate)
  // const poptions = getOptionsWithRowData?getOptionsWithRowData(getFieldValue):options;
  
  const rules =_.isFunction(_options)?[{required: isRequired,message:<Language id="required"/>},({ getFieldValue }) => ({
            validator:(_, value)=>{                         
              if(!shouldUpdate)return Promise.resolve();
              if (!value || _options({},getFieldValue()).map(o=>o.key).includes(value))return Promise.resolve();
              
              return Promise.reject(new Error('Please change Fuel Type based on the selected Equipment Type'));
            },
          })]:[{required: isRequired,message:<Language id="required"/>}];
  
   const isVisible = ({key,parentData,hidden})=>{
      
      if(key=="id")return false;
      if(!key.includes("fuelId"))return !hidden;
      const number = key.match(/fuelId(\d+)/)?.[1];
      if(!number)return true
      
      if(number<=parentData?.value?.fuel?.length)return true
      
      return false
      
      }
      
  const isHidden = !isVisible({key,parentData,hidden});
  console.log("isHidden",isHidden);
  return (shouldUpdate?
  <Form.Item 
      key={`${parentKey||"key"}-${key}`} 
      noStyle
      shouldUpdate={true}
      >{
       ({getFieldValue})=><Form.Item 
      label={hideLabel?undefined:label||key} 
      name={parentKey?[...parentKey,key]:key} 
      required={isRequired} 
      dependencies={dependencies}
      // shouldUpdate={shouldUpdate}
      shouldUpdate={true}
      hidden={isHidden}
      tooltip={tooltip}
      rules={rules}
      
      {...other} 
       
       
       >
      {getInput({...inputs,ref,type,format,showSearch,options:(_.isFunction(_options)&&_options(parentData,form.getFieldsValue()))||_options})}
      </Form.Item>
      }
     </Form.Item>:
  
  <Form.Item 
      key={`${parentKey||"key"}-${key}`} 
      label={hideLabel?undefined:label||key} 
      name={parentKey?[...parentKey,key]:key} 
      required={isRequired} 
      dependencies={dependencies}
      // shouldUpdate={shouldUpdate}
      shouldUpdate={true}
      hidden={isHidden}
      tooltip={tooltip}
      rules={rules}
      
      {...other}>{getInput({...inputs,ref,type,format,showSearch,options:(_.isFunction(_options)&&_options(parentData,form.getFieldsValue()))||_options})}
     </Form.Item>
  
     
     
   )
}